module.exports = __webpack_public_path__ + "static/media/protect-5.9b775343.png";